import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'xt-portal-dialog-footer',
  templateUrl: './dialog-footer.component.html',
  styleUrls: ['./dialog-footer.component.scss'],
    standalone: false
})
export class DialogFooterComponent {
  @Input() cancelBtnText;
  @Input() confirmBtnText;
  @Input() dataCy: string = '';

  @Output() closeDialog = new EventEmitter();
  @Output() confirm = new EventEmitter();

  onClose(): void {
    this.closeDialog.emit();
  }

  onConfirm(): void {
    this.confirm.emit();
  }
}
